import React, { useEffect, useState } from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { addOther, editOther } from "../JS/actions/other";

const AddOther = () => {
  const [other, setOther] = useState({});
  const [edit, setEdit] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const otherToEdit = useSelector((state) => state.otherReducers.other);

  useEffect(() => {
    if (params.id) {
      setEdit(true);
    } else {
      setEdit(false);
    }
    edit
      ? setOther(otherToEdit)
      : setOther({
          title: "",
          description: "",
          qte: "",
        });
  }, [params, edit, otherToEdit]);
  const handleChange = (e) => {
    setOther({ ...other, [e.target.name]: e.target.value });
  };
  const handleSave = (e) => {
    e.preventDefault();
    if (edit) {
      dispatch(editOther(params.id, other, history));
      alert("event updated succesfully :)");
    } else {
      dispatch(addOther(other, history));
      alert(" added succesfully :)");
    }
  };
  return (
    <div>
      <Form className="addFamily">
        <h1 style={{ textAlign: "center", color: "black" }}>
          {" "}
          Ajouter un element{" "}
        </h1>

        <Row className="mb-3">
          <Form.Group as={Col}>
            <Form.Label>Titre</Form.Label>
            <Form.Control
              onChange={handleChange}
              type="text"
              placeholder="Entrez le titre"
              name="title"
              required
              value={other.title}
            />
          </Form.Group>

          <Form.Group as={Col}>
            <Form.Label> Desription</Form.Label>
            <Form.Control
              onChange={handleChange}
              type="text"
              placeholder="Description"
              name="description"
              required
              value={other.description}
            />
          </Form.Group>
        </Row>
        <Form.Group as={Col}>
          <Form.Label>Quantité</Form.Label>
          <Form.Control
            onChange={handleChange}
            type="number"
            placeholder="qte"
            name="qte"
            required
            value={other.qte}
          />
        </Form.Group>
        {/* <Form.Group as={Col} controlId="formGridState">
          <Form.Label>Type event</Form.Label>
          <Form.Select
            onChange={handleChange}
            placeholder="Type event"
            name="eventType"
            type="text"
            defaultValue="Choose..."
            required
          >
            <option>Choisir...</option>
            <option>evennement</option>
            <option>action</option>
          </Form.Select>
        </Form.Group> */}

        <Row className="mb-3"></Row>

        <Button
          onClick={handleSave}
          style={{ marginBottom: "15px" }}
          variant="primary"
          type="submit"
        >
          Submit
        </Button>
      </Form>
    </div>
  );
};

export default AddOther;
